import { createSlice } from "@reduxjs/toolkit";
import {
  getUser,
  getUserComment,
  getLocalUser,
  updateUsers,
  updatelocalUser,
} from "../3- actions/users";
// import { reset } from "../3- actions/novels";
export const counterSlice = createSlice({
  name: "auth",
  initialState: {
    LocalUser: [],
    user: [],
    userComment: [],
  },
  reducers: {
    CLEAR_USER(state) {
      state.user = [];
      state.user.pending = true;
      state.userComment = [];
      state.userComment.pending = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLocalUser.fulfilled, (state, action) => {
      state.LocalUser = action.payload;
    });
    builder.addCase(updatelocalUser.fulfilled, (state, action) => {
      state.LocalUser =
        state.LocalUser._id === action.payload._id
          ? action.payload
          : state.LocalUser;
    });
    builder.addCase(getUser.fulfilled, (state, action) => {
      state.user = {
        ...state.user,
        users: action.payload,
        pending: false,
      };
    });
    builder.addCase(getUser.pending, (state, action) => {
      state.user = {
        ...state.user,
        pending: true,
      };
    });
    builder.addCase(updateUsers.fulfilled, (state, action) => {
      state.user = {
        ...state.user,
        users:
          state.user.users._id === action.payload._id
            ? action.payload
            : state.user.users,
      };
    });
    builder.addCase(getUserComment.fulfilled, (state, action) => {
      state.userComment = {
        ...state.userComment,
        users: [...(state.userComment.users || ""), ...action.payload],
        pending: false,
      };
    });
    builder.addCase(getUserComment.pending, (state, action) => {
      state.userComment = {
        ...state.userComment,
        pending: true,
      };
    });
  },
});

export default counterSlice.reducer;
export const { CLEAR_USER } = counterSlice.actions;
